class MainSearch extends HTMLFormElement {
  constructor() {
    super();
    this._onResetClick = (event) => this.resetSearch(event);
    this._onInput = () => this.toggleResetButton();
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._input = this.querySelector('input[type="search"]');
    this._resetButton = this.querySelector('button[type="reset"]');

    if (!this._input || !this._resetButton) return;

    this._resetButton.addEventListener('click', this._onResetClick);
    this._input.addEventListener('input', this._onInput);
    this.toggleResetButton();
  }

  disconnectedCallback() {
    this._resetButton?.removeEventListener('click', this._onResetClick);
    this._input?.removeEventListener('input', this._onInput);
    this._initialized = false;
  }

  toggleResetButton() {
    this._resetButton?.classList.toggle('hidden', !this._input.value.trim());
  }

  resetSearch(event) {
    event?.preventDefault();

    this._input.value = '';
    this._resetButton.classList.add('hidden');
    this._input.focus();

    if (this.dataset.performed === 'true') {
      window.location.assign(this.getAttribute('action') || window.routes?.search_url);
    }
  }
}

if (!customElements.get('main-search')) {
  customElements.define('main-search', MainSearch, { extends: 'form' });
}
